import React from 'react';
import { getPageLogoUrl, intl } from 'ehs-react';

function LogoComponent(): React.JSX.Element {
  return (
    <header className="welcome-logo-container" role="banner">
      <a
        href={SenseConstants.logoutUrl}
        className="logo default-logo"
        title={intl('common.link.loginpage')}
        tabIndex={0}
      >
        <img
          className="welcome-logo"
          src={getPageLogoUrl()}
          alt={`${intl('common.logo.tooltip')} ${SenseConstants.company}`}
        />
      </a>
    </header>
  );
}

export const Logo = LogoComponent;
